module.exports = __webpack_public_path__ + "static/img/qrcode.8a217f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/qrcode.jpg
// module id = DNXQ
// module chunks = 1